import { AgenticLogicRuleRunListItemDto } from "@intelligems/ig-types/functions/agentic-logic/runs/list";
import {
  GetAgenticLogicRuleRunRequestPathParamsType,
  GetAgenticLogicRuleRunResponseBodyType,
} from "@intelligems/ig-types/functions/agentic-logic/runs/get";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

// Intelligems-staff only; see list-agentic-logic-rule-runs.ts.

const getAgenticLogicRuleRun = async (
  pathParams: GetAgenticLogicRuleRunRequestPathParamsType
) => {
  const resp = await api.get<GetAgenticLogicRuleRunResponseBodyType>(
    `/v2/agentic-logic/rules/${pathParams.ruleId}/runs/${encodeURIComponent(
      pathParams.invocationId
    )}`
  );
  return resp.data;
};

/**
 * One run's detail. The list row carries the telemetry and captured logs, so
 * it seeds the query as `initialData` and the dialog opens instantly; the
 * fetch is what brings in the input/output capture, which the list omits
 * because the panel polls it.
 */
export const useAgenticLogicRuleRun = (
  ruleId: string | undefined,
  invocationId: string | null,
  initialRun?: AgenticLogicRuleRunListItemDto
) => {
  return useQuery<GetAgenticLogicRuleRunResponseBodyType, Error>({
    queryKey: agenticLogicKeys.run(ruleId!, invocationId ?? ""),
    queryFn: async () =>
      getAgenticLogicRuleRun({ ruleId: ruleId!, invocationId: invocationId! }),
    enabled: !!ruleId && invocationId !== null,
    initialData: initialRun ? { run: initialRun } : undefined,
    // The seed is a list row and is stale on arrival: the app's default
    // staleTime would otherwise treat it as fresh and never fetch the capture.
    initialDataUpdatedAt: 0,
    staleTime: 0,
  });
};
